(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-choice-button/assets/javascripts/odds-button.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-choice-button/assets/javascripts/odds-button.js');
"use strict";


const CouponChoiceLink = svs.components.tipsen.couponChoiceButton.CouponChoiceLink;
const TipsenModuleGameUrl = svs.components.sport.tipsenShared.TipsenModuleGameUrl;
const getRelativeUrl = svs.components.tipsen.couponChoiceButton.getRelativeUrl;
const OddsButton = _ref => {
  let routesMatch = _ref.routesMatch,
    toParams = _ref.toParams;
  return React.createElement(CouponChoiceLink, {
    ariaLabel: "Odds - Visa mina eller mest och minst spelade odds",
    className: "coupon-toolbox-odds-button",
    icon: "odds",
    to: {
      pathname: getRelativeUrl(routesMatch.url, TipsenModuleGameUrl.ODDS),
      search: "?".concat(toParams)
    }
  }, "Odds");
};
setGlobal('svs.components.tipsen.couponChoiceButton.OddsButton', OddsButton);

 })(window);